/**
 * Install the browser's adapters.
 *
 * Called once from `main.tsx` before anything touches the database. Every
 * platform-specific decision this app makes is reachable from here, which is
 * the property worth keeping: the answer to "what does the web do differently?"
 * is this file and the six modules beside it, not a grep across `src/`.
 */
import { configurePlatform } from '@kapture/platform';
import { api } from '@/lib/api/client';
import { API_BASE } from '@/lib/api/base';
import { webSqliteDriver } from './webSqliteDriver';
import { opfsMediaStore } from './opfsMediaStore';
import { webNetwork } from './webNetwork';
import { webLifecycle } from './webLifecycle';
import { webIds } from './webIds';
import { idbSecureStore } from './idbSecureStore';

export function installWebPlatform(): void {
  configurePlatform({
    apiBaseUrl: API_BASE,
    db: webSqliteDriver,
    media: opfsMediaStore,
    net: webNetwork,
    lifecycle: webLifecycle,
    ids: webIds,
    secureStore: idbSecureStore,
    api,
  });
}
